import { isNil } from 'lodash';
import React from 'react';
import { CS_REVIEW_DETAIL_URL_PATH } from '../../../constants/service/common/urlConstants';
import { setDetailPageUrl } from '../../../lib/common';
import Anchor from '../Anchor';

interface OpenReviewDetailProps {
  text?: string;
  reviewId: number;
}

const OpenReviewDetail = (props: OpenReviewDetailProps) => {
  const { text, reviewId } = props;

  /**
   * 링크로 연결할 데이터가 없다면
   * '-' 를 반환함
   */
  if (isNil(text) && isNil(reviewId)) {
    return <>'-'</>;
  }

  return (
    <Anchor
      text={text}
      isUnderLine
      color="primary"
      href={setDetailPageUrl(CS_REVIEW_DETAIL_URL_PATH, reviewId)}
      target="_blank"
    />
  );
};

export default OpenReviewDetail;
